import script from "./goRinSyo0068.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0068.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0068.vue?vue&type=style&index=0&id=2eb3a90c&lang=scss"

const __exports__ = script;

export default __exports__